import {
  Form,
  Input,
  Select,
  Row,
  Col,
  DatePicker,
  Card,
  message,
  List,
  Button
} from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import "./regissterbwc.css";
import React, { useState ,useEffect} from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { GreenButton } from "../../components/button/GreenButton";
import { GuestLayout } from "../../components/layout/guest-layout";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

export const PATCH = async (path, data) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };
  try {
    const response = await instance.patch(`${path}`, data, config);
    data = await response.data;
    return data;
  } catch (error) {
    console.log(error.response);
    throw error.response;
  }
};


export const POST = async (path, data, header) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };
  try {
    const response = await instance.post(
      `/${path}`,
      data,
      header ? header : config
    );
    console.log(config);
    data = await response.data;
    return data;
  } catch (error) {
    throw error.response;
  }
};
  

export const GET = async (path, header) => {
  // Set default headers with Authorization token
  const defaultConfig = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };

  // Merge custom headers if provided
  const config = header ? { ...defaultConfig, ...header } : defaultConfig;

  try {
    // Perform GET request
    const response = await instance.get(path, config);
    const data = response.data;
    return data;
  } catch (error) {
    // Log error response
    console.log(error.response);
    throw error.response;
  }
};

export default function Registerbwc() {
  const [update, setupdate] = useState(false);
  const [form] = Form.useForm();
  const [searchResults, setSearchResults] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [userID, setuserID] = useState("");
  const [Ordernumber, setOrdernumber] = useState('');
  const [foundorder, setFoundorder] = useState(false);
  const [findorder, setFindorder] = useState(false);
  const [Phonenumber, setPhonenumber] = useState('');
  const { Option } = Select;

  const location = useLocation();

  

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const jwtToken = queryParams.get("id");

    if (jwtToken !== null) {
      const decodedUrl = decodeURIComponent(jwtToken);
      const decodedToken = jwtDecode(decodedUrl);
      setuserID(decodedToken.userID);
    } else {
      console.error("'id' parameter not found in URL");
    }
  }, [location.search]);

  const onFinish = async (e) => {
    if(foundorder === true){
      try {
        const register =await PATCH('update_customer_name_phone/', e);
        if (register === "This order is exist") {
          setupdate(false);
          message.error(`เลข order ถูกลงทะเบียนไปแล้ว`);
        } else {
          setupdate(true);
        }
      } catch (error) {
        console.error(error);
      }
    }else{
      const updatedValue = {
        warrantyHead: {
          ...e,
          addedBy: userID
        },
        warrantyLine: selectedItems,
      };
      try {
        const register = await POST("bwc_register_warranty/", updatedValue);
        if (register === "This order is exist") {
          setupdate(false);
          message.error(`เลข order ถูกลงทะเบียนไปแล้ว`);
        } else {
          setupdate(true);
        }
      } catch (error) {
        console.error(error);
      }
    }
    
  };
  const onSearch = async (e) => {
    if (e.length > 5) {
      try {
        const findsku = await GET("get_products/" + e);
        if (findsku) {
          console.log(findsku);
          setSearchResults(findsku);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const checksku = async () => {
    if(Ordernumber !== ''){
      try {
        const checkorder = await GET(`check_order_num_exist/${Ordernumber}`);
        console.log(checkorder);
        setFoundorder(checkorder);
        setFindorder(true);
        if(checkorder === true){
          message.success(`พบเลขคำสั่งซื้อในระบบ`);
        }else{
          message.error(`ไม่พบเลขคำสั่งซื้อ กรุณากรอกรายละเอียด`);
        }
        
      } catch (error) {
        console.log(error);
      }
      
    }
  }

  const handleSelect = (value) => {
    const selectedItem = searchResults.find(item => item.SKU === value);
    if (selectedItem) {
      setSelectedItems(prevItems => {
        const existingItem = prevItems.find(item => item.SKU === value);
        if (existingItem) {
          // If the item already exists, increment the quantity
          return prevItems.map(item =>
            item.SKU === value ? { ...item, QTY: item.QTY + 1 } : item
          );
        } else {
          // If the item doesn't exist, add it with a quantity of 1
          return [...prevItems, { ...selectedItem, QTY: 1 }];
        }
      });
      setSearchValue(''); // Clear the input field
      setSearchResults([]); // Clear the search results
    }
  };
  const handleDelete = (sku) => {
    setSelectedItems(prevItems => prevItems.filter(item => item.SKU !== sku));
  };
  const Phonenumberinput = (e) => {
      setPhonenumber(e.target.value);
  }

  const ordernumberinput = (e) => {
    setOrdernumber(e.target.value);
}

  return (
    <GuestLayout title={"ลงทะเบียนรับประกันสินค้า"}>
      <div className="textinput">
        <div className="subtextinput">
          <div className="title">
            <h2 style={{ padding: "20px" }}>
              ลงทะเบียนรับประกันสินค้า สำหรับ Bewell care
              <br />
              Warranty Registration
            </h2>
          </div>
          {update === true ? (
            <Card style={{ width: 400, margin: "auto", marginTop: "50px" }}>
              <Row justify="center" align="middle">
                <Col>
                  <CheckCircleOutlined
                    style={{ fontSize: "50px", color: "#52c41a" }}
                  />
                </Col>
              </Row>
              <Row justify="center" align="middle">
                <Col>
                  <h3 style={{ fontSize: "30px", color: "#52c41a" }}>
                    Success
                  </h3>
                </Col>
              </Row>
            </Card>
          ) : (
            <Form
              layout="vertical"
              className="Form"
              form={form}
              onFinish={onFinish}
            >
              <Form.Item
                rules={[
                  { required: true, message: "กรุณากรอกเลขที่คำสั่งซื้อ" },
                ]}
                label="เลขที่คำสั่งซื้อ (Order ID)"
                name="OrderNumber"
              >
                <Input placeholder="เลขที่คำสั่งซื้อ" name="OrderNumber" onChange={ordernumberinput}/>
              </Form.Item>
              <Form.Item style={{display:'flex', justifyContent:'center'}}>
                <Button onClick={checksku}>
                    check order
                </Button>
              </Form.Item>

              {findorder && foundorder ? (
                <>
                  <Form.Item
                  label="ชื่อ-นามสกุล"
                  name="CustFullname"
                  rules={[{ required: true, message: 'กรุณากรอกชื่อ' }]}
                >
                  <Input placeholder="กรอกชื่อ" name="CustFullname" />
                </Form.Item>
                <Form.Item
                rules={[
                  { required: true, message: "กรุณากรอกเบอร์" },
                  { pattern: /^[0-9]*$/, message: "กรุณากรอกตัวเลขเท่านั้น" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (
                        !value ||
                        (value.length === 10 && value.length >= 10)
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("เบอร์โทรต้องมีความยาว 10 ตัวเลข")
                      );
                    },
                  }),
                ]}
                label="เบอร์โทรติดต่อ (Phone number)"
                name="CustPhoneNumber"
              >
                <Input placeholder="เบอร์โทร" name="CustPhoneNumber" required onChange={Phonenumberinput}/>
              </Form.Item>
                </>
              
            ) : findorder && !foundorder ? (
              <>
               <Form.Item
                  label="ชื่อ-นามสกุล"
                  name="custFullname"
                  rules={[{ required: true, message: 'กรุณากรอกชื่อ' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                rules={[
                  { required: true, message: "กรุณากรอกเบอร์" },
                  { pattern: /^[0-9]*$/, message: "กรุณากรอกตัวเลขเท่านั้น" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (
                        !value ||
                        (value.length === 10 && value.length >= 10)
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("เบอร์โทรต้องมีความยาว 10 ตัวเลข")
                      );
                    },
                  }),
                ]}
                label="เบอร์โทรติดต่อ (Phone number)"
                name="custPhoneNumber"
              >
                <Input placeholder="เบอร์โทร" name="custPhoneNumber" required onChange={Phonenumberinput}/>
              </Form.Item>
              <Form.Item
                rules={[
                  { required: true, message: "กรุณาเลือกช่องทางที่ซื้อ" },
                ]}
                name="purchaseChannel"
                label="ช่องทางการซื้อสินค้า (Channel)"
              >
                <Select
                  name="purchaseChannel"
                  placeholder="เลือกช่องทางที่ซื้อ"
                  showSearch
                >
                  <Select.Option value="b2s">B2S</Select.Option>
                  <Select.Option value="banana">Banana IT</Select.Option>
                  <Select.Option value="betrend">BeTrend</Select.Option>
                  <Select.Option value="bes">
                    Bewell Ergonomic Space
                  </Select.Option>
                  <Select.Option value="homepro">Homepro</Select.Option>
                  <Select.Option value="lazada">Lazada</Select.Option>
                  <Select.Option value="loft">Loft</Select.Option>
                  <Select.Option value="medium_and_more">
                    Medium and More
                  </Select.Option>
                  <Select.Option value="mercular">Mercular</Select.Option>
                  <Select.Option value="nocnoc">NocNoc</Select.Option>
                  <Select.Option value="powerbuy">Powerbuy</Select.Option>
                  <Select.Option value="sb">SB Design Square</Select.Option>
                  <Select.Option value="se_ed">SE-ED Book Center</Select.Option>
                  <Select.Option value="shopee">Shopee</Select.Option>
                  <Select.Option value="tiktok">TikTok</Select.Option>
                  <Select.Option value="website">Website</Select.Option>
                  <Select.Option value="zeenzone">ZeenZone</Select.Option>
                  <Select.Option value="commart">งาน Commart</Select.Option>
                  <Select.Option value="baanlaesuan">
                    งานบ้านและสวนแฟร์
                  </Select.Option>
                  <Select.Option value="events">งาน Event อื่น ๆ</Select.Option>
                  <Select.Option value="others">ช่องทางอื่น ๆ</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                rules={[
                  { required: true, message: "กรุณากรอกวันที่รับสินค้า" },
                ]}
                label="วันที่รับสินค้า (Purchase Date)"
                name="purchaseDate"
              >
                <DatePicker
                  style={{ width: "100%" }}
                  allowClear
                  format="YYYY-MM-DD"
                  placeholder="เลือกวันที่"
                />
              </Form.Item>
              <Form.Item
              label="ค้นหาสินค้า">
                
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Select a product"
                  optionFilterProp="children"
                  onSearch={onSearch}
                  onChange={handleSelect}
                  value={searchValue}
                  filterOption={false} // Disable built-in filtering to use custom search
                >
                  {searchResults.map((item) => (
                    <Option key={item.SKU} value={item.SKU}>
                      {item.ItemName}
                    </Option>
                  ))}
                </Select>
                <List
                  header={<div>รายการในบิล</div>}
                  bordered
                  dataSource={selectedItems}
                  renderItem={(item) => (
                    <List.Item
                    actions={[
                      <Button type="link" onClick={() => handleDelete(item.SKU)}>Delete</Button>
                    ]}>
                      {item.ItemName} จำนวน: {item.QTY}
                    </List.Item>
                  )}
                  style={{ marginTop: 16 }}
                />
              </Form.Item>
              </>
            ) : (
              null
            )}
            {findorder && (
                <Form.Item>
                  <GreenButton block htmlType="submit">
                    บันทึกข้อมูล
                  </GreenButton>
                </Form.Item>
            )}
              
            </Form>
          )}
        </div>
      </div>
    </GuestLayout>
  );
}
